webpackJsonp([216929306842663],{

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _qs = __webpack_require__(58);
	
	var _domFormSerializer = __webpack_require__(56);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _DownloadForm = __webpack_require__(445);
	
	var _DownloadForm2 = _interopRequireDefault(_DownloadForm);
	
	__webpack_require__(386);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HomeForm = function (_React$Component) {
	  _inherits(HomeForm, _React$Component);
	
	  function HomeForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HomeForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      fields: {
	        centre: 'East Malvern'
	      }
	    }, _this.handleChange = function (e) {
	      e.persist();
	      _this.setState(function (prevState) {
	        var _extends2;
	
	        return {
	          fields: _extends({}, prevState.fields, (_extends2 = {}, _extends2[e.target.name] = e.target.value, _extends2))
	        };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HomeForm.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        name = _props.name,
	        subject = _props.subject,
	        action = _props.action,
	        handbookDownload = _props.handbookDownload;
	
	
	    var centres = ['East Malvern', 'Mildura', 'Mildura Central'];
	
	    var fields = this.state.fields;
	    var centre = fields.centre;
	
	
	    var title = 'Download Our Family Handbook';
	    var description = _react2.default.createElement(
	      _react.Fragment,
	      null,
	      'Fill out the form and download our family handbook or ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/contact' },
	        'contact us'
	      )
	    );
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'download-banner home-download' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        centres.map(function (centreItem, index) {
	          return _react2.default.createElement(_DownloadForm2.default, {
	            key: 'Home Download ' + index,
	            active: centre === centreItem,
	            formName: centreItem + ' Download Form',
	            fields: fields,
	            handleChange: _this2.handleChange,
	            title: title,
	            description: description,
	            handbookDownload: handbookDownload
	          });
	        })
	      ),
	      _react2.default.createElement(_Image2.default, { background: true, src: '/images/uploads/handbook.jpg', alt: 'image of handbook' })
	    );
	  };
	
	  return HomeForm;
	}(_react2.default.Component);
	
	exports.default = HomeForm;
	module.exports = exports['default'];

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 607:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.HomePageTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get2 = __webpack_require__(14);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _PageHeader = __webpack_require__(15);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Wave = __webpack_require__(378);
	
	var _Wave2 = _interopRequireDefault(_Wave);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _HomeDownloadBanner = __webpack_require__(597);
	
	var _HomeDownloadBanner2 = _interopRequireDefault(_HomeDownloadBanner);
	
	var _JoinBanner = __webpack_require__(64);
	
	var _JoinBanner2 = _interopRequireDefault(_JoinBanner);
	
	var _ExceedBanner = __webpack_require__(28);
	
	var _ExceedBanner2 = _interopRequireDefault(_ExceedBanner);
	
	var _Button = __webpack_require__(26);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	__webpack_require__(702);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var HomePageTemplate = exports.HomePageTemplate = function HomePageTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      featuredImage = _ref.featuredImage,
	      homeSection1 = _ref.homeSection1,
	      homeSection2 = _ref.homeSection2,
	      homeSection3 = _ref.homeSection3,
	      homeSection4 = _ref.homeSection4,
	      footerSettings = _ref.footerSettings,
	      meta = _ref.meta;
	
	  // showHandbook
	
	  var handbookDownload = (0, _get3.default)(footerSettings, 'handbookDownload') || [];
	
	  return _react2.default.createElement(
	    'main',
	    { className: 'Home' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { defaultTitle: meta ? meta.title : title + ' | Great Start ELC' },
	      meta && _react2.default.createElement('meta', { name: 'description', content: meta.description }),
	      meta && _react2.default.createElement('link', { rel: 'canonical', href: meta.canonicalLink })
	    ),
	    _react2.default.createElement(_PageHeader2.default, {
	      large: true,
	      title: title,
	      subtitle: subtitle,
	      button: { linkTo: '/enrolments/enrolling-great-start-early-learing-centre/', title: 'Enrol Now' },
	      backgroundImage: featuredImage
	    }),
	    homeSection1 && _react2.default.createElement(
	      'div',
	      { className: 'section homeSection1' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container taCenter' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          homeSection1.title
	        ),
	        homeSection1.centres && _react2.default.createElement(
	          'div',
	          { className: 'homeSection1--boxes' },
	          homeSection1.centres.map(function (centre, index) {
	            return _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                key: 'centre' + index,
	                className: 'hasBorder hasShadowHover homeSection1--box',
	                to: centre.linkTo
	              },
	              _react2.default.createElement(_Image2.default, {
	                className: 'homeSection1--box--logo',
	                src: centre.logo,
	                alt: centre.title || centre.description
	              }),
	              _react2.default.createElement(
	                'p',
	                { className: 'homeSection1--box--description' },
	                centre.description
	              ),
	              _react2.default.createElement(
	                'strong',
	                null,
	                'View Centre'
	              )
	            );
	          })
	        )
	      )
	    ),
	    homeSection2 && _react2.default.createElement(
	      'div',
	      { className: 'section dots-left light homeSection2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container homeSection2--container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'relative' },
	          _react2.default.createElement(_Image2.default, {
	            background: true,
	            src: homeSection2.image,
	            alt: homeSection2.title
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'h2',
	            null,
	            homeSection2.title
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'strong',
	              null,
	              homeSection2.subtitle
	            )
	          ),
	          _react2.default.createElement(_Content2.default, { src: homeSection2.content }),
	          _react2.default.createElement(
	            _Button2.default,
	            { to: homeSection2.linkTo },
	            'Read More'
	          )
	        )
	      )
	    ),
	    homeSection3 && _react2.default.createElement(
	      'div',
	      { className: 'section homeSection3' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          homeSection3.title
	        ),
	        homeSection3.items && _react2.default.createElement(
	          'div',
	          { className: 'homeSection3--items' },
	          homeSection3.items.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'homeSection3--item', key: item.title },
	              _react2.default.createElement(
	                'div',
	                { className: 'homeSection3--item--icon' },
	                _react2.default.createElement(_Image2.default, {
	                  src: item.icon,
	                  alt: item.title
	                })
	              ),
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  { className: 'homeSection3--item--title' },
	                  item.title
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  item.subtitle
	                )
	              )
	            );
	          })
	        )
	      )
	    ),
	    homeSection4 && _react2.default.createElement(
	      'div',
	      { className: 'section dots-right' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'homeSection4--grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'homeSection4--grid--image relative' },
	            _react2.default.createElement(_Image2.default, { background: true, src: homeSection4.image1, alt: title })
	          ),
	          homeSection4.items && homeSection4.items.map(function (item, index) {
	            var col = 'col' + (index + 1);
	            return _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: item.linkTo,
	                className: 'homeSection4--grid--item hasShadowHover ' + col,
	                key: item.title
	              },
	              _react2.default.createElement(
	                'h3',
	                { className: 'homeSection4--grid--item--title' },
	                item.title
	              ),
	              _react2.default.createElement(_Wave2.default, null),
	              _react2.default.createElement(
	                'p',
	                { className: 'homeSection4--grid--item--description' },
	                item.description
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'Button homeSection4--grid--item--button' },
	                'Read More'
	              )
	            );
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'homeSection4--grid--image relative' },
	            _react2.default.createElement(_Image2.default, { background: true, src: homeSection4.image2, alt: title })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section thin JoinBannerSection' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_JoinBanner2.default, { linkTo: '/' })
	      )
	    ),
	    _react2.default.createElement(_HomeDownloadBanner2.default, { handbookDownload: handbookDownload }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section thin' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_ExceedBanner2.default, { footerSettings: footerSettings })
	      )
	    )
	  );
	};
	
	// Export Default HomePage for front-end
	var HomePage = function HomePage(_ref2) {
	  var _ref2$data = _ref2.data,
	      markdownRemark = _ref2$data.markdownRemark,
	      footerSettings = _ref2$data.footerSettings;
	  return _react2.default.createElement(HomePageTemplate, _extends({}, markdownRemark.frontmatter, { footerSettings: footerSettings }));
	};
	exports.default = HomePage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-home-page-js-33fbe449a513ccbc73c7.js